import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import VoucherInfo from './VoucherInfo';
import * as orderActions from './../../../../../../actions/orderAction';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openModalDetail: () => dispatch(orderActions.openModalDetail()),
        createFlightTracking: (data) => dispatch(orderActions.createFlightTracking(data)),
        updateFlightTracking: (data) => dispatch(orderActions.updateFlightTracking(data)),
        deleteFlightTracking: (data) => dispatch(orderActions.deleteFlightTracking(data)),
        getListFlightTrackingOrder: (orderId) => dispatch(orderActions.getListFlightTrackingOrder(orderId))

    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(VoucherInfo));